var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-card",
        { staticClass: "cardClassDetailForm", attrs: { title: "상세" } },
        [
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-md-4 col-lg-4" },
              [
                _c("c-label-text", {
                  attrs: {
                    title: "재해발생원인(인적)",
                    value: _vm.accData.accidentCause,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-md-4 col-lg-4" },
              [
                _c("c-label-text", {
                  attrs: {
                    title: "재해발생원인(물적)",
                    value: _vm.accData.accidentCauseM,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-md-4 col-lg-4" },
              [
                _c("c-label-text", {
                  attrs: {
                    title: "재해발생원인(환경적)",
                    value: _vm.accData.accidentCauseE,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-md-4 col-lg-4" },
              [
                _c("c-label-text", {
                  attrs: {
                    title: "재발방지대책(공학적)",
                    value: _vm.accData.engineeringRecurrence,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-md-4 col-lg-4" },
              [
                _c("c-label-text", {
                  attrs: {
                    title: "재발방지대책(관리적)",
                    value: _vm.accData.managementRecurrence,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-md-4 col-lg-4" },
              [
                _c("c-label-text", {
                  attrs: {
                    title: "환경안경팀 의견",
                    value: _vm.accData.managerOpinion,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [_c("c-upload", { attrs: { editable: false } })],
              1
            ),
          ]),
        ],
        2
      ),
      _c("br"),
      _c(
        "c-table",
        {
          ref: "tableImpr",
          attrs: {
            title: "수시 위험성평가",
            columns: _vm.gridImpr.columns,
            gridHeight: _vm.gridImpr.height,
            data: _vm.accData.accidentImproveModelList,
            filtering: false,
            columnSetting: false,
            usePaging: false,
            editable: false,
          },
          on: { "table-data-change": _vm.tableDataChange },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "customCol"
                    ? [
                        _c(_vm.imprComponent, {
                          tag: "component",
                          attrs: {
                            col: col,
                            props: props,
                            inputEditable: false,
                            isImmShow: true,
                            requestContentsCols: _vm.requestContentsCols,
                            tableKey: "causesNo",
                            ibmTaskTypeCd: "ITT0000040",
                            ibmTaskUnderTypeCd: "ITTU000065",
                          },
                          on: { imprChange: _vm.imprChange },
                        }),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c("q-chip", {
                attrs: {
                  icon: "info",
                  color: "blue",
                  size: "16px",
                  square: "",
                  outline: "",
                  clickable: "",
                  label: "위험성 판단 기준",
                  dense: "",
                },
                on: {
                  click: function ($event) {
                    _vm.riskCriteriaPopup = true
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "q-dialog",
        {
          model: {
            value: _vm.riskCriteriaPopup,
            callback: function ($$v) {
              _vm.riskCriteriaPopup = $$v
            },
            expression: "riskCriteriaPopup",
          },
        },
        [
          _c(
            "q-card",
            { staticStyle: { "min-width": "500px", "max-width": "70vw" } },
            [
              _c(
                "q-card-section",
                { staticClass: "row items-center q-pb-none" },
                [
                  _c("q-icon", {
                    staticClass: "q-mr-sm",
                    attrs: { name: "play_circle_outline", size: "xs" },
                  }),
                  _c("b", [_vm._v("위험성 판단 기준")]),
                  _c("q-space"),
                  _c("q-btn", {
                    directives: [
                      { name: "close-popup", rawName: "v-close-popup" },
                    ],
                    attrs: {
                      icon: "close",
                      size: "sm",
                      flat: "",
                      round: "",
                      dense: "",
                    },
                  }),
                ],
                1
              ),
              _c("q-card-section", [
                _c("table", { staticClass: "riskCriteriaTable" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", { staticStyle: { width: "20%" } }, [
                        _vm._v("위험성 수준"),
                      ]),
                      _c("th", [_vm._v("판단 기준")]),
                      _c("th", { staticStyle: { width: "15%" } }, [
                        _vm._v("허용 가능 여부"),
                      ]),
                    ]),
                  ]),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", { staticClass: "riskLevelCell riskLevelHigh" }, [
                        _c("b", { staticClass: "text-red q-mr-sm" }, [
                          _vm._v("상(빨강)"),
                        ]),
                        _vm._v(": 매우높음"),
                      ]),
                      _c("td", { staticClass: "riskCriteriaCell" }, [
                        _vm._v(
                          " · 사고 발생 시 사망 또는 장애가 남을 수 있는 위험"
                        ),
                        _c("br"),
                        _vm._v(
                          " · 산업안전보건법에 따른 기준을 만족시키지 못한 경우 "
                        ),
                      ]),
                      _c("td", { attrs: { rowspan: "2" } }, [
                        _vm._v("허용 불가능"),
                        _c("br"),
                        _vm._v("(개선 후 작업)"),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "riskLevelCell riskLevelMid" }, [
                        _c("b", { staticClass: "text-amber q-mr-sm" }, [
                          _vm._v("중(노랑)"),
                        ]),
                        _vm._v(": 보통"),
                      ]),
                      _c("td", { staticClass: "riskCriteriaCell" }, [
                        _vm._v(" · 사고 발생 시 3일 이상의 휴업이 필요한 경우"),
                        _c("br"),
                        _vm._v(" · 아차사고 사례가 있는 경우 "),
                      ]),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "riskLevelCell riskLevelLow" }, [
                        _c("b", { staticClass: "text-green q-mr-sm" }, [
                          _vm._v("하(초록)"),
                        ]),
                        _vm._v(": 매우낮음"),
                      ]),
                      _c("td", { staticClass: "riskCriteriaCell" }, [
                        _vm._v(
                          " · 3일 미만의 휴업 또는 작업 수행에 영향을 미치지 않는 경미한 부상 또는 질병이 예상되는 경우 "
                        ),
                      ]),
                      _c("td", [_vm._v("허용가능")]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }